export const EXSBINVOICEPOSITION_DELETE_RESET = 'EXSBINVOICEPOSITION_DELETE_RESET'
export const EXSBINVOICEPOSITION_DELETE_SET_ERROR = 'EXSBINVOICEPOSITION_DELETE_SET_ERROR'
export const EXSBINVOICEPOSITION_DELETE_SET_DELETED = 'EXSBINVOICEPOSITION_DELETE_SET_DELETED'
export const EXSBINVOICEPOSITION_DELETE_TOGGLE_LOADING = 'EXSBINVOICEPOSITION_DELETE_TOGGLE_LOADING'
